import { DanceStyleStatusEnum } from '../enums';

export interface DanceStyleInterface {
  id?: string;
  translationKey?: string;
  danceStyleStatus?: DanceStyleStatusEnum;
  isPairDance?: boolean;
}
